import {
  SUM_FUNCTION_NAME
} from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/WaterfallFundSummaryParser/WaterfallFundSummaryParser.constants';

export const buildExitProceedsExpr = (entityId: number | string, additionalEntityIds?: (number | string)[]) => {
  const baseExpr = `FundInvestment_${entityId}__f.totalValue`;

  if (!additionalEntityIds || additionalEntityIds.length === 0) {
    return `=${baseExpr}`;
  }

  const additionalExprs = additionalEntityIds.map(id => `FundInvestment_${entityId}_${id}__f.totalValue`);
  const allExprs = [baseExpr, ...additionalExprs];

  return `=${SUM_FUNCTION_NAME}(${allExprs.join(', ')})`;
};
// MOIC expression builder; expects fully-qualified cell refs for exit, previous, and invested
export const buildMoicExpr = (exitRef: string, prevRef: string, investedRef: string) => `=(${exitRef}+${prevRef})/${investedRef}`;